export const Issue_identified_prompt_buttons = [
    {
        buttonTxt: 'Tell me more about the issue',
        message: 'Tell me more about the issue',
        displayMessage: 'Tell me more about the issue',
        action: 'follow_up',
        context: 'issue_identification'
    },
    {
        buttonTxt: 'Help me find a resolution',
        message: 'Please guide me through each step starting with the first one. Please only present one step at a time. If statements are for you to decide what next step to present based on my answer, please do not present any if statements in your answer.',
        displayMessage: 'Help me find a resolution',
        action: 'find_resolution',
        context: 'issue_resolution'
    }
];

export const Context_failed_prompt_buttons = [
    {
        buttonTxt: 'Issue Identification',
        message: '',
        displayMessage: 'Please answer this in the context of Issue Identification',
        context: 'issue_identification',
        action: ''
    },
    {
        buttonTxt: 'Issue Resolution',
        message: '',
        displayMessage: 'Please answer this in the context of Issue Resolution',
        context: 'issue_resolution',
        action: ''
    },
    {
        buttonTxt: 'Environment Variables',
        message: '',
        displayMessage: 'Please answer this in the context of Environment Variables',
        context: 'environment',
        action: ''
    },
    {
        buttonTxt: 'Business Use Case',
        message: '',
        displayMessage: 'Please answer this in the context of Business Use Case',
        context: 'business',
        action: ''
    },
    {
        buttonTxt: 'CG&S Use Case',
        message: '',
        displayMessage: 'Please answer this in the context of CG&S Use Case',
        context: 'cgs',
        action: ''
    }
];